var _ = require('underscore');
var TorsoListView = require('backbone-torso/modules/ListView');
var payableBillListTemplate = require('./payableBillsListTemplate.hbs');
var SecureMessageAccountBillView = require('./SecureMessageAccountBillView');
var SecureMessageDataBehavior = require('./../secure-message/SecureMessageDataBehavior');

/**
 * Customizations to the SecureMessageWidget specific to the outstanding bills list in e-reg or pre-reg.
 * @class PayableBillsListWidget
 * @constructor
 * @extends TorsoListView
 */
module.exports = TorsoListView.extend({
  tagName: 'ol',
  className: 'brec-list',
  template: payableBillListTemplate,
  itemContainer: 'payable-bills',
  itemView: SecureMessageAccountBillView,

  behaviors: {
    payableBills: {
      behavior: SecureMessageDataBehavior,
      alwaysFetch: true,
      ids: function(cache) {
        var criteria = {
          billCriteria: {
            billCriteria: {
              current: true,
              show: true,
              minAccountBalance: 0.01,
              statuses: ['UNPAID']
            }
          },
          isPatient: true,
          vecnaIds: null
        };
        return cache.fetchIdsByCriteria(criteria);
      }
    }
  },

  /**
   * @method getTotalUnpaidBillsAmount
   * @returns {Number} the total amount that the patient has in unpaid bills.
   */
  getTotalUnpaidBillsAmount: function() {
    var payableBills = this.collection.models;
    var amountsDue = _.map(payableBills, function(payableBillSecureMessageModel) {
      return payableBillSecureMessageModel.get('billDTO.externalBill.accountBalance');
    });
    return _.reduce(amountsDue, function(result, amount) {
      return result + amount;
    }, 0);
  },

  /**
   * @method initialize
   * @override
   */
  initialize: function() {
    var billsBehavior = this.getBehavior('payableBills');
    this.collection = billsBehavior.data.privateCollection;
    this.listenTo(billsBehavior, 'fetched', function() {
      this.trigger('change:totalUnpaidBillsAmount');
    });
  },

  /**
   * @method getPayableBillsCount
   * @returns {Number} the number of payable bills fetched from the server.  returns 0 if none have been fetched.
   */
  getPayableBillsCount: function() {
    var payableBillsCount = this.collection && this.collection.length;
    return payableBillsCount || 0;
  },

  /**
   * @method hasPayableBills
   * @returns {Boolean} true if there are any payable bills to display.
   */
  hasPayableBills: function() {
    return this.getPayableBillsCount() > 0;
  },

  /**
   * @method hasBillsWithoutAccountNumber
   * @returns {boolean} true if there are any bills without account number
   */
  hasBillsWithoutAccountNumber: function() {
    return this._getBillsWithoutAccountNumberCount() > 0;
  },

  /**
   * @method allBillsWithoutAccountNumber
   * @returns {boolean} true if all the bills are without account number
   */
  allBillsWithoutAccountNumber: function() {
    var totalCount = this.getPayableBillsCount();
    var billsWithoutAccountNumberCount = this._getBillsWithoutAccountNumberCount();
    var allBillsDoNotHaveAccountNumber = totalCount === billsWithoutAccountNumberCount;
    return this.hasBillsWithoutAccountNumber() && allBillsDoNotHaveAccountNumber;
  },

  /**
   * @method _getBillsWithoutAccountNumberCount
   * @returns {Number} the number of  bills without account number
   * @private
   */
  _getBillsWithoutAccountNumberCount: function() {
    var billsWithoutAccountNumber = _.filter(this.collection.models, function(bill) {
      return !bill.get('billDTO.accountNumber');
    });
    var countWithoutAccountNumber = billsWithoutAccountNumber && billsWithoutAccountNumber.length;
    return countWithoutAccountNumber || 0;
  }
});
